/**
 * UI theming. Three skins applied via a `data-ui` attribute on <html>:
 *   default  — the current sleek dark/gold HUD
 *   kenney   — full Kenney Fantasy UI Borders framing (9-slice)
 *   relikara — the most on-brand Relikara identity: arcane purple + pale gold,
 *              serif headers, glowing frames, and ZERO emojis (icons become SVG)
 *
 * The default comes from the .env value VITE_UI_THEME; the player can switch at
 * runtime and that choice is persisted to localStorage (which overrides .env).
 */
const KEY = "relikara.uiTheme.v2";   // bumped so the new default applies over old saved prefs
export const UI_THEMES = ["default", "kenney", "relikara"];
export const UI_THEME_LABELS = { default: "Classic", kenney: "Fantasy", relikara: "Relikara" };
// Themes offered to players in the switcher (Fantasy/kenney is hidden until it's polished).
export const UI_THEMES_VISIBLE = ["relikara", "default"];

export function currentTheme() {
  try { const s = localStorage.getItem(KEY); if (s && UI_THEMES.includes(s)) return s; } catch (_) {}
  const envd = (import.meta.env && import.meta.env.VITE_UI_THEME) || "relikara";
  return UI_THEMES.includes(envd) ? envd : "relikara";
}

export function applyTheme(name) {
  const t = UI_THEMES.includes(name) ? name : currentTheme();
  document.documentElement.setAttribute("data-ui", t);
  return t;
}

export function setTheme(name) {
  if (!UI_THEMES.includes(name)) return;
  try { localStorage.setItem(KEY, name); } catch (_) {}
  applyTheme(name);
}

export function initTheme() { return applyTheme(currentTheme()); }

/** True when the active theme forbids emoji (icons should render as SVG). */
export function emojiFree() { return document.documentElement.getAttribute("data-ui") === "relikara"; }
